<script lang="ts">
	import { PageBody } from '#lib/features/navigation/components/PageBody/index.js';
	import { Container } from '$global/components/Container';
	import {
		Markdown,
		type MarkdownTokenList,
	} from '$global/components/Markdown';
	import { Txt } from '$global/components/Txt';

	interface Props {
		terms: MarkdownTokenList;
		title: string;
		dataCy: string;
	}

	let { terms, title, dataCy }: Props = $props();
</script>

<PageBody class="mb-0 bg-gray-100 pb-10 lg:mb-0 lg:pb-[4rem]">
	<Container
		{dataCy}
		class="grid grid-cols-1 gap-6 pt-10 lg:grid-cols-4 lg:pt-[5rem]"
	>
		<Txt variant="h4" class="mb-6 lg:col-span-1">{title}</Txt>
		<Markdown
			size="medium"
			source={terms}
			{dataCy}
			class="terms lg:col-span-3"
		/>
	</Container>
</PageBody>

<!-- TODO: handle this is in the Markdown component -->
<style>
	:global(table) {
		margin-bottom: 3rem;
	}

	:global(.terms th) {
		width: 50%;
		text-align: center;
		padding: 24px;
	}

	:global(.terms td) {
		width: 50%;
		text-align: center;
		padding: 8px;
	}
</style>
